import { render, staticRenderFns } from "./StockTransitDialog.vue?vue&type=template&id=4c951cbe&scoped=true&"
import script from "./StockTransitDialog.vue?vue&type=script&lang=js&"
export * from "./StockTransitDialog.vue?vue&type=script&lang=js&"
import style0 from "./StockTransitDialog.vue?vue&type=style&index=0&id=4c951cbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c951cbe",
  null
  
)

export default component.exports